module.exports = "../media/def14de2f25677b791d40769c581ff34.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/parent.png
// module id = 518
// module chunks = 0